import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IApproveGrammarPointsV1Request } from './approve-grammar-points-v1-request';
import type { IApproveGrammarPointsV1Response } from './approve-grammar-points-v1-response';
import { approveGrammarPointsV1ResponseSchema } from './approve-grammar-points-v1-response';

export async function approveGrammarPointsV1Api(
  body: IApproveGrammarPointsV1Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IApproveGrammarPointsV1Response>> {
  return putRequest<IApproveGrammarPointsV1Response>({
    path: '/sys/grammar/v1/points/approve',
    body,
    schema: approveGrammarPointsV1ResponseSchema,
    options,
  });
}
